import { Component, Input, Output, TemplateRef, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-text-area-field',
  templateUrl: './text-area-field.component.html',
  styleUrls: ['./text-area-field.component.scss']
})
export class TextAreaFieldComponent  {

	@Input() nzSuffix: TemplateRef<any>;
	@Input() form: FormGroup;
	@Input() label: string;
	@Input() placeholder: string;
	@Input() formName: string;
	@Input() size: string;
	@Input() footNote: string = "";
	@Input() showValidationError: boolean = true;
	@Input() fieldSize;
	@Output() ngModelChange = new EventEmitter<any>();
  @Input() inputGroupClass: string;


	handleOnChange( $event ) {
		// ... all of your logic
		this.ngModelChange.emit( $event ); // this will pass the $event object to the parent component.
	}

}
